import React from 'react';
import { ReferenceInput, SelectInput, Filter, TextInput, List, ShowButton, Show, SimpleShowLayout, Datagrid, TextField, ReferenceField } from 'react-admin';
import JsonField from './JsonField';

const AuditListFilters = (props) => {
  return <Filter {...props}>
    <TextInput label="Event" source="event"/>
    <TextInput label="Record Type" source="auditable_type"/>
    <TextInput label="Record Id" source="auditable_id"/>
    <ReferenceInput label="User" source="user_id" reference="user" allowEmpty>
      <SelectInput optionText="name"/>
    </ReferenceInput>
  </Filter>;
}

export const AuditList = (props) => {
  return <List {...props} filters={<AuditListFilters/>} bulkActions={false}>
    <Datagrid>
      <TextField source="id" />
      <ReferenceField label="User" source="user_id" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="event" />
      <TextField source="auditable_type" />
      <TextField source="auditable_id" />
      <TextField source="created_at" />
      <ShowButton />
    </Datagrid>
  </List>;
};

export const AuditShow = (props) => {
  return  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField label="User" source="user_id" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="event" />
      <TextField source="auditable_type" />
      <TextField source="auditable_id" />
      <JsonField source="old_values" />
      <JsonField source="new_values" />
      <TextField source="ip_address" />
      <TextField source="user_agent" />
      <TextField source="created_at" />
    </SimpleShowLayout>
  </Show>;
};


// WEBPACK FOOTER //
// ./resources/assets/js/audit.js